import { Injectable } from '@angular/core';
import { AppConfig, UvExplorerClient } from 'common';
import { Observable, Subject } from 'rxjs/Rx';
import { ValueEncoder } from "DiscoveryEngine.TS/Utils";
import { UpdateResultDto } from "UvExplorerServer.Dtos.TS";
import { ShareDto, GetSharesResultDto } from 'UvExplorerServer.Dtos.TS';

@Injectable()
export class ShareWebService {
	constructor(private appConfig: AppConfig, private uvExplorerClient: UvExplorerClient) {
		return;
	}

	public getShares(shareType: string, dataSelector: string): Observable<GetSharesResultDto> {
		let body = {
			get_shares_request: {
				share_type: shareType,
				data_selector: dataSelector,
			}
		};

		let url = this.appConfig.configServiceUrl + `api/config/shares/user`;
		return this.uvExplorerClient.postObjSer<GetSharesResultDto>(url, body, GetSharesResultDto);
	}

	public createShare(share: ShareDto): Observable<ShareDto> {
		let body = {
			create_share_request: {}
		};
		share.Write(body.create_share_request, {});

		let url = this.appConfig.configServiceUrl + `api/config/shares`;
		let subject = new Subject<ShareDto>();

		this.uvExplorerClient.postObjSer<UpdateResultDto>(url, body, UpdateResultDto).subscribe(
			(result: UpdateResultDto) => {
				share.CopyProps(result, true);
				subject.next(share);
			},
			(error?) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public updateShare(share: ShareDto): Observable<ShareDto> {
		let body = {
			update_share_request: {}
		};
		share.Write(body.update_share_request, {});

		let url = this.appConfig.configServiceUrl + `api/config/shares`;
		let subject = new Subject<ShareDto>();

		this.uvExplorerClient.putObjSer<UpdateResultDto>(url, body, UpdateResultDto).subscribe(
			(result: UpdateResultDto) => {
				share.CopyProps(result, false);
				subject.next(share);
			},
			(error?) => {
				console.error(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public deleteShareByGuid(guid: string): Observable<boolean> {
		let body = {
			delete_share_request: {
				share_guid: guid
			}
		};

		let url = this.appConfig.configServiceUrl + `api/config/shares`;
		return this.uvExplorerClient.deleteNoResult(url, body);
	}

}